function FinalizeSettlement(): JSX.Element {
  return <div></div>;
}

export default FinalizeSettlement;
